var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.589844,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#003588"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_4627)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_80_4627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0004 19.3398C23.7872 19.3398 18.7502 24.3398 20.0004 30.5898C20.8873 35.0238 25.5489 39.1433 28.1829 41.1628C28.8836 41.7001 29.2341 41.9687 29.7479 42.0364C29.8943 42.0557 30.1066 42.0557 30.2529 42.0364C30.7668 41.9687 31.1171 41.7002 31.8178 41.1629C34.4519 39.1433 39.1137 35.0238 40.0004 30.5898C41.2502 24.3398 36.2136 19.3398 30.0004 19.3398Z",
    stroke: "#ECF2FF",
    strokeWidth: 1.45161,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.75 29.5273C33.75 31.5984 32.0711 33.2773 30 33.2773C27.9289 33.2773 26.25 31.5984 26.25 29.5273C26.25 27.4563 27.9289 25.7773 30 25.7773C32.0711 25.7773 33.75 27.4563 33.75 29.5273Z",
    stroke: "#ECF2FF",
    strokeWidth: 1.45161,
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_4627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(15 15.5898)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_80_4627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(15 15.5898)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.dcd28674a97929d8d90506a67532d7bd.svg";
export { ForwardRef as ReactComponent };